import { Injectable, inject } from '@angular/core';
import { HttpInterceptor, HttpEvent, HttpResponse, HttpRequest, HttpHandler } from '@angular/common/http';
import { catchError, finalize, Observable, tap, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { deleteUser } from '../STORE/actions/auth.actions';
import { reducers } from '../STORE/reducers/reducers';
import { getPendingService } from '../services/pendingHttpServices.service';
import { AppGlobalService } from '../services/app.global.service';
import { setAllApps, setApps } from '../STORE/actions/applifecycle.actions';
import { setUsers } from '../STORE/actions/users.actions';
import { UtilService } from '../services/util.service';

@Injectable()
export class ApiInterceptor implements HttpInterceptor {
  private router = inject(Router);
  private store = inject(Store);
  private loaderService = inject(getPendingService);
  private appGlobalService = inject(AppGlobalService);
  private utilService = inject(UtilService);
  private requests: HttpRequest<any>[] = [];
  private excudedPostCalls = [
    'datatable',
    'viewers',
    'project/create',
    'codegenerator/generate',
    'codegenerator/pushuilibraries',
    'codegenerator/pushbelibraries',
    'deltasql/generate',
    'fetchDocuments',
    'apps/refs/create',
    'updatedefaultbranch',
  ]

  removeRequest(req: HttpRequest<any>) {
    const i = this.requests.indexOf(req);
    if (i >= 0) {
      this.requests.splice(i, 1);
    }
    this.loaderService.isPending.next(this.requests.length > 0);
  }

  intercept(httpRequest: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Add CSRF token header for all requests
    const csrfToken = this.utilService.getCookie('XSRF-TOKEN');
    if (csrfToken) {
      httpRequest = httpRequest.clone({
        setHeaders: {
          'XSRF-TOKEN': csrfToken
        },
        withCredentials: true
      });
    }

    const isExcludedPost =
      httpRequest.method === 'POST' && this.excudedPostCalls.some((url) => httpRequest.url.includes(url));

    if (!(isExcludedPost || httpRequest.method === 'GET')) {
      this.requests.push(httpRequest);
      this.loaderService.isPending.next(true);
    }

    const start = performance.now();

    return next.handle(httpRequest).pipe(
      tap((event: HttpEvent<any>) => {
        if (!(isExcludedPost || httpRequest.method === 'GET')) {
          this.appGlobalService.apiStatusJson.updateFlag = true;
          this.appGlobalService.apiStatusJson.updateFlagContent = 'Saving';
          this.appGlobalService.apiStatusJson.class = 'info';
          // console.log("Enter")
        }
        this.appGlobalService.write('count', (parseInt(this.appGlobalService.get('count') || 0) + 1).toString());
        //console.log('REQ COUNT :: ', this.appGlobalService.get('count'));
        if (event instanceof HttpResponse) {
          const successHttpStatusCodes = [200, 204];
          if (successHttpStatusCodes.includes(event.status)) {
            if (!(isExcludedPost || httpRequest.method === 'GET')) {
              // console.log("Enter 1")
              this.appGlobalService.apiStatusJson.updateFlagContent = 'Saved';
              this.appGlobalService.apiStatusJson.class = 'success';
              this.appGlobalService.apiStatusJson.updateFlag = true;
              setTimeout(() => {
                this.appGlobalService.apiStatusJson.updateFlag = false;
              }, 500);
            }
          } else if (!(isExcludedPost || httpRequest.method === 'GET')) {
            this.appGlobalService.apiStatusJson.updateFlagContent = 'Not Saved';
            this.appGlobalService.apiStatusJson.class = 'error';
            this.appGlobalService.apiStatusJson.updateFlag = true;
            setTimeout(() => {
              this.appGlobalService.apiStatusJson.updateFlag = false;
            }, 500);
          }
          const end = performance.now();
          const perf = `${((end - start) / 1000).toFixed(2)} seconds`;
          this.consoleLogger([httpRequest.url, httpRequest.method, perf]);
        }
      }),
      catchError((error: any) => {
        if (!(isExcludedPost || httpRequest.method === 'GET')) {
          this.appGlobalService.apiStatusJson.updateFlagContent = 'Not Saved';
          this.appGlobalService.apiStatusJson.class = 'error';
          this.appGlobalService.apiStatusJson.updateFlag = true;
          setTimeout(() => {
            this.appGlobalService.apiStatusJson.updateFlag = false;
          }, 500);
        }
        if (error.status === 401) {
          this.store.dispatch(deleteUser({ userData: error?.error?.msg || 'UNAUTHENTICATED_USER' }));
          Object.keys(reducers).map((red: string) => {
            localStorage.removeItem(red);
          });
          this.store.dispatch(setApps({ appList: [] }));
          this.store.dispatch(setAllApps({ allAppList: [], totalRecords: 0 }));
          this.store.dispatch(setUsers({ usersData: [], totalRecords: 0 }));
          if (this.router.url !== '/login' && !this.router.url.startsWith('/login')) {
            this.router.navigateByUrl('/login').catch((err) => {
              console.error(err);
            });
          }
        }
        return throwError(error);
      }),
      finalize(() => {
        if (!(isExcludedPost || httpRequest.method === 'GET')) {
          this.removeRequest(httpRequest);
        }
      })
    );
  }

  consoleLogger(metrics) {
    //if(!environment.hmr) {return}
    function log(url, method, requestTime) {
      this.URL = url;
      this.METHOD = method;
      this.REQUESTTIME = requestTime;
    }
    // const logged = new Log(metrics[0], metrics[1], metrics[2]);
    //console.table(logged);
  }
}
